import { render, staticRenderFns } from "./EchartsPieChart.vue?vue&type=template&id=8f7cf916"
import script from "./EchartsPieChart.vue?vue&type=script&lang=js"
export * from "./EchartsPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports